import { ButtonLink } from "@/components/marketing/elements/button"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { MinimalMarketingLayout } from "@/components/marketing/MinimalMarketingLayout"
import { NoIndexHead } from "@/components/marketing/NoIndexHead"
import { DocumentCentered } from "@/components/marketing/sections/document-centered"
import { isLaunchMode } from "@/lib/launch-config"

/** Not prerendered, so it only ever renders client-side after the host has
 *  already served some other file -- same launch-mode chrome as the legal
 *  pages so a mistyped URL still looks like the site it landed on. */
export function NotFoundPage() {
  const Layout = isLaunchMode() ? MinimalMarketingLayout : MarketingLayout

  return (
    <Layout>
      <NoIndexHead />
      <DocumentCentered
        headline="Page not found"
        subheadline={<p>The page you are looking for does not exist.</p>}
      >
        <ButtonLink href="/">Go home</ButtonLink>
      </DocumentCentered>
    </Layout>
  )
}
